import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import cityDepoReducer from './cityDepoSlice';

// code for redux persist
import storage from 'redux-persist/lib/storage';
// import storageSession from 'reduxjs-toolkit-persist/lib/storage/session'
// import storageSession from 'redux-persist/lib/storage/session'
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const persistConfig = {
  key: 'root',
  storage,
}

const persistConfigCityDepo = {
  key: 'city_depo',
  storage,
};

// const persistConfig = {
//   key: 'root',
//   storageSession,
// }

const persistedReducer = persistReducer(persistConfig, userReducer)
const persistedCityDepoReducer = persistReducer(persistConfigCityDepo, cityDepoReducer);
// code for redux persist

export const store = configureStore({
  reducer: {
    // user: userReducer,
    user: persistedReducer,// code for redux persist
    city_depo: persistedCityDepoReducer,
    // city_depo: cityDepoReducer,
    middleware: [thunk]// code for redux persist
    // Add other reducers as needed.
  },
});

export const persistor = persistStore(store)
// export default store;